// Shared data for the R&D funded-projects portfolio (/proyectos + /proyectos/:slug)
// Source: internal innovation portfolio playbook (27 proyectos, 2012–2029, ~16 M€ de cartera)
// EN fields (*En) provide the real English translation used on /en/projects and /en/projects/:slug.

export const PORTFOLIO_STATS = {
  total: 27,
  presupuesto: '~16 M€',
  patentes: 17,
};

// Spanish estado -> English label (grouping key `estado` stays in Spanish, used internally)
export const ESTADO_EN = {
  Activo: 'Active',
  'En justificación': 'In closeout',
  Completado: 'Completed',
};

export const PROJECTS = [
  {
    slug: 'cirtexcam',
    name: 'CIRTEXCAM',
    estado: 'Activo',
    periodo: '2026–2028',
    financiador: 'Consorcio: FECSA, UDIT, Tecnalia, AITEX, Hilaturas Arnau, Tree Technology, T-Neutral, EvoEncyme, Globalfactor, AseCom',
    financiadorEn: 'Consortium: FECSA, UDIT, Tecnalia, AITEX, Hilaturas Arnau, Tree Technology, T-Neutral, EvoEncyme, Globalfactor, AseCom',
    desc: 'Pasar el textil de lineal a circular: menos materia prima importada, valorizar residuo textil y reincorporarlo.',
    descEn: 'Turning textiles from linear to circular: less imported raw material, valorizing textile waste and putting it back into use.',
    longDesc: 'CIRTEXCAM busca transformar la industria textil hacia un modelo circular. Su objetivo es reducir la dependencia de materia prima virgen y valorizar el residuo textil para su reincorporación en la producción. El proyecto implementa soluciones para el reciclaje y la reutilización de textiles, promoviendo una gestión de recursos más sostenible.',
    longDescEn: 'CIRTEXCAM aims to transform the textile industry into a circular model. It seeks to reduce dependency on virgin raw material and valorize textile waste for reincorporation into production. The project implements solutions for recycling and reusing textiles, promoting more sustainable resource management.',
  },
  {
    slug: 'civic',
    name: 'CIVIC (LIFE Cáceres)',
    estado: 'Activo',
    periodo: '2026–2029',
    financiador: 'LIFE · socios Candam, Smart to People, Fenix TNT, Cámara de Cáceres',
    financiadorEn: 'LIFE · partners Candam, Smart to People, Fenix TNT, Cáceres Chamber of Commerce',
    desc: 'Digitalizar la gestión municipal de envases (IoT, IA, incentivos PAYT) para subir reciclaje y trazabilidad. Ciudad de referencia: Cáceres.',
    descEn: 'Digitalizing municipal packaging waste management (IoT, AI, PAYT incentives) to boost recycling and traceability. Reference city: Cáceres.',
    longDesc: 'CIVIC es un proyecto LIFE en Cáceres que digitaliza la gestión municipal de envases. Incorpora IoT, IA e incentivos PAYT para aumentar el reciclaje y la trazabilidad, estableciendo un modelo innovador para la gestión de residuos de envases.',
    longDescEn: 'CIVIC is a LIFE project in Cáceres that digitalizes municipal packaging waste management. It incorporates IoT, AI and PAYT incentives to increase recycling and traceability, establishing an innovative model for packaging waste management.',
  },
  {
    slug: 'valdesc',
    name: 'VALDESC',
    estado: 'Activo',
    periodo: '2025–2027',
    financiador: 'CDTI',
    financiadorEn: 'CDTI',
    desc: 'Recuperación de residuos de construcción y demolición. Acelerar el salto a economía circular en construcción.',
    descEn: 'Recovery of construction and demolition waste. Accelerating the shift to a circular economy in construction.',
    longDesc: 'Recuperación de residuos de construcción y demolición. Acelerar el salto a economía circular en construcción.',
    longDescEn: 'Recovery of construction and demolition waste. Accelerating the shift to a circular economy in construction.',
    presupuestoK: 446,
  },
  {
    slug: 'digital-waste',
    name: 'DIGITAL WASTE',
    estado: 'Activo',
    periodo: '2023–2026',
    financiador: 'CDTI · socio Itainnova',
    financiadorEn: 'CDTI · partner Itainnova',
    desc: 'Gemelo digital de planta de RSU: escenarios de operación y predicción de anomalías. IA, IoT y gemelos para optimizar.',
    descEn: 'Digital twin of an MSW plant: operating scenarios and anomaly prediction. AI, IoT and digital twins to optimize.',
    longDesc: 'Gemelo digital de planta de RSU: escenarios de operación y predicción de anomalías. IA, IoT y gemelos para optimizar.',
    longDescEn: 'Digital twin of an MSW plant: operating scenarios and anomaly prediction. AI, IoT and digital twins to optimize.',
    presupuestoK: 392,
  },
  {
    slug: 'rahp',
    name: 'RAHP',
    estado: 'Activo',
    periodo: '2023–2026',
    financiador: 'Socio Itainnova',
    financiadorEn: 'Partner Itainnova',
    desc: 'Proceso escalable para reducir a vertedero los residuos de productos higiénicos absorbentes, recuperando y valorizando materiales.',
    descEn: 'Scalable process to divert absorbent hygiene product waste from landfill, recovering and valorizing materials.',
    longDesc: 'RAHP desarrolla un proceso escalable para la gestión de residuos de productos higiénicos absorbentes. Busca reducir su destino a vertedero mediante la recuperación y valorización de sus materiales, ofreciendo una solución circular y sostenible para este tipo de residuos.',
    longDescEn: 'RAHP develops a scalable process for managing absorbent hygiene product waste. It seeks to reduce landfill disposal through material recovery and valorization, offering a circular, sustainable solution for this type of waste.',
  },
  {
    slug: 'tecnocir',
    name: 'TECNOCIR',
    estado: 'En justificación',
    periodo: 'Fin oficial 31/03/2026 · defensa CDTI octubre 2026',
    periodoEn: 'Official end 31/03/2026 · CDTI defense October 2026',
    financiador: 'CDTI (alias PTEC)',
    financiadorEn: 'CDTI (alias PTEC)',
    desc: 'Revalorización de residuos industriales. Economía circular multi-sector.',
    descEn: 'Revalorization of industrial waste. Multi-sector circular economy.',
    longDesc: 'TECNOCIR desarrolla soluciones de economía circular para la revalorización de residuos industriales. El proyecto busca transformar estos residuos en recursos valiosos, promoviendo la sostenibilidad y la eficiencia en diversos sectores.',
    longDescEn: 'TECNOCIR develops circular-economy solutions for revalorizing industrial waste. The project aims to turn this waste into valuable resources, promoting sustainability and efficiency across multiple sectors.',
  },
  {
    slug: 'sos-agua-xxi',
    name: 'SOS AGUA XXI',
    estado: 'Completado',
    periodo: '01/09/2021–30/06/2025',
    financiador: 'NextGenerationEU (alias interno: Agricultura 4.0)',
    financiadorEn: 'NextGenerationEU (internal alias: Agriculture 4.0)',
    desc: 'Acciones para impulsar el sector agrario español (Misión Agricultura del siglo XXI). Sostenibilidad hídrica y uso eficiente del agua.',
    descEn: 'Actions to boost the Spanish agricultural sector (21st Century Agriculture Mission). Water sustainability and efficient use.',
    longDesc: 'Acciones para impulsar el sector agrario español (Misión Agricultura del siglo XXI). Sostenibilidad hídrica y uso eficiente del agua.',
    longDescEn: 'Actions to boost the Spanish agricultural sector (21st Century Agriculture Mission). Water sustainability and efficient use.',
    presupuestoK: 506,
  },
  {
    slug: 'ciclicom',
    name: 'CÍCLICOM',
    estado: 'Completado',
    periodo: 'Cierre oficial 18/06/2026',
    periodoEn: 'Official closing 18/06/2026',
    financiador: 'CDTI + UE',
    financiadorEn: 'CDTI + EU',
    desc: 'Ecosistema de innovación para la circularidad de materiales compuestos y plásticos complejos.',
    descEn: 'Innovation ecosystem for the circularity of composite materials and complex plastics.',
    longDesc: 'Ecosistema de innovación para la circularidad de materiales compuestos y plásticos complejos.',
    longDescEn: 'Innovation ecosystem for the circularity of composite materials and complex plastics.',
    presupuestoK: 328,
  },
  {
    slug: 'valrec',
    name: 'VALREC',
    estado: 'Completado',
    periodo: '01/11/2021–31/10/2023',
    financiador: 'CDTI',
    financiadorEn: 'CDTI',
    desc: 'Circularidad, trazabilidad y pureza de recursos minerales en RCD.',
    descEn: 'Circularity, traceability and purity of mineral resources in C&D waste.',
    longDesc: 'VALREC se centra en mejorar la circularidad de los Residuos de Construcción y Demolición (RCD). El proyecto asegura la trazabilidad y pureza de los recursos minerales recuperados, facilitando su reintroducción en la cadena de valor.',
    longDescEn: 'VALREC focuses on improving the circularity of Construction and Demolition Waste (C&D). The project ensures traceability and purity of recovered mineral resources, facilitating their reintroduction into the value chain.',
  },
  {
    slug: 'cents4pack',
    name: 'CENTS4PACK',
    estado: 'Completado',
    periodo: '01/08/2022–31/01/2025',
    financiador: 'LIFE / partners',
    financiadorEn: 'LIFE / partners',
    desc: 'Sistema de recompensa por reciclar envases correctamente. Gamificación y participación ciudadana.',
    descEn: 'Reward system for recycling packaging correctly. Gamification and citizen participation.',
    longDesc: 'CENTS4PACK implementa un sistema de recompensa para incentivar el reciclaje correcto de envases. Mediante gamificación y participación ciudadana, fomenta la separación adecuada de residuos.',
    longDescEn: 'CENTS4PACK implements a reward system to incentivize correct packaging recycling. Through gamification and citizen participation, it encourages proper waste separation.',
  },
  {
    slug: 'microuwas',
    name: 'MICROUWAS',
    estado: 'Completado',
    periodo: '01/06/2020–31/03/2024',
    financiador: 'Socios CBGP y Bioproces',
    financiadorEn: 'Partners CBGP and Bioproces',
    desc: 'Digestor anaerobio piloto a pequeña escala para identificar poblaciones microbianas y controlar biotecnológicamente la biometanización.',
    descEn: 'Small-scale pilot anaerobic digester to identify microbial populations and biotechnologically control biomethanization.',
    longDesc: 'MICROUWAS ha diseñado un digestor anaerobio piloto para investigar poblaciones microbianas y controlar biotecnológicamente la biometanización, mejorando la eficiencia de la producción de biogás.',
    longDescEn: 'MICROUWAS has designed a pilot anaerobic digester to research microbial populations and biotechnologically control biomethanization, improving biogas production efficiency.',
  },
  {
    slug: 'encapsulados',
    name: 'ENCAPSULADOS',
    estado: 'Completado',
    periodo: '01/04/2021–31/01/2024',
    financiador: 'Instituto Tecnológico de Aragón',
    financiadorEn: 'Aragón Technology Institute',
    desc: 'Mejorar encapsulados de NFU (color y propiedades a la intemperie) y automatizar fabricación. Nueva vida a neumáticos fuera de uso.',
    descEn: 'Improving end-of-life tire encapsulations (color and weathering properties) and automating manufacturing. New life for end-of-life tires.',
    longDesc: 'ENCAPSULADOS se enfoca en la mejora de los encapsulados de Neumáticos Fuera de Uso (NFU). Busca optimizar color y propiedades a la intemperie, y automatizar su fabricación.',
    longDescEn: 'ENCAPSULADOS focuses on improving end-of-life tire (ELT) encapsulations. It seeks to optimize color and weathering properties, and automate manufacturing.',
  },
  {
    slug: 'suschempol',
    name: 'SUSCHEMPOL',
    estado: 'Completado',
    periodo: '01/09/2021–01/09/2024',
    financiador: 'Consorcio CSIC / GAIKER / Repsol / Arkema / Nasika / VSM',
    financiadorEn: 'Consortium CSIC / GAIKER / Repsol / Arkema / Nasika / VSM',
    desc: 'Reciclado químico a monómeros de valor y polímeros más sostenibles (eco-diseño).',
    descEn: 'Chemical recycling into valuable monomers and more sustainable polymers (eco-design).',
    longDesc: 'SUSCHEMPOL explora el reciclado químico para obtener monómeros y polímeros más sostenibles. Promueve el eco-diseño de materiales, buscando alternativas circulares y reduciendo la dependencia de recursos fósiles.',
    longDescEn: 'SUSCHEMPOL explores chemical recycling to obtain more sustainable monomers and polymers. It promotes material eco-design, seeking circular alternatives and reducing dependency on fossil resources.',
  },
  {
    slug: 'co2mcrete',
    name: 'CO2MCRETE',
    estado: 'Completado',
    periodo: '01/10/2024–31/10/2025',
    financiador: 'CDTI + UE',
    financiadorEn: 'CDTI + EU',
    desc: 'CO₂ mineralizado en cementos y hormigones a partir de residuos y escorias activados térmicamente.',
    descEn: 'CO₂ mineralized in cements and concretes from thermally activated waste and slag.',
    longDesc: 'CO2MCRETE investiga la captura y mineralización de CO₂ en cementos y hormigones. Utiliza residuos y escorias activados térmicamente para fijar el CO₂, creando materiales de construcción con menor huella de carbono.',
    longDescEn: 'CO2MCRETE investigates the capture and mineralization of CO₂ in cements and concretes. It uses thermally activated waste and slag to fix CO₂, creating construction materials with a lower carbon footprint.',
    presupuestoK: 386,
  },
];

export const HISTORIC_PROJECTS = [
  { name: 'HOJAS', years: '2012–2014' },
  { name: 'LIXIVIADOS', years: '2014–2015' },
  { name: 'NFU', years: '2014–2016' },
  { name: 'GIS', years: '2015–2016' },
  { name: 'VIDRIO', years: '2015–2016' },
  { name: 'C2C', years: '2015–2017' },
  { name: 'S4CITIZENS', years: '2016–2017' },
  { name: 'NUEVO ADITIVO', years: '2016–2018' },
  { name: 'SILENT RUBBER PAVEMENT', years: '2017–2020' },
  { name: 'BARREDORA 3D SMART CLEANING', years: '2017–2019' },
  { name: 'GORDON', years: '2018–2021' },
  { name: 'INSIGHT', years: '2018–2021' },
  { name: 'BATTERY LESS SENSOR', years: '2020–2021' },
];
